// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3_6yj","content":"LoadingAlert_content__3Hb1R"};